import { boardsActions } from "./BoardsReducer";

/**
 * Runs `create` while `BoardsReducer.newWaBoardStatus` is "creating WA board", and ALWAYS
 * resets it to "" afterwards (success or throw). tasks-panel.tsx renders neither the group
 * list nor the empty state while the status is non-empty, so a status that is never cleared
 * leaves the tasks drawer blank (#733).
 */
export const withNewWaBoardStatus = async <T>(
  dispatch: (action: ReturnType<typeof boardsActions.setNewWaBoardStatus>) => unknown,
  create: () => Promise<T>
): Promise<T> => {
  dispatch(boardsActions.setNewWaBoardStatus("creating WA board"));
  try {
    return await create();
  } finally {
    dispatch(boardsActions.setNewWaBoardStatus(""));
  }
};
